import React from 'react';
import { routes } from '../routes/routes';
import { apiRoutes } from '../api/apiRoutes';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBox from '@mui/icons-material/AccountBox';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import Speed from '@mui/icons-material/Speed';
import BadgeIcon from '@mui/icons-material/Badge';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TaskIcon from '@mui/icons-material/Task';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';

export const companySidebarItems = [
  {
    title: 'SIDEBAR.GROUP_COMPANY_MANAGEMENT',
    items: [
      {
        title: 'SIDEBAR.EMPLOYEES',
        icon: <BadgeIcon />,
        url: routes.admin.employees.list,
        apiUrl: apiRoutes.employees.list,
      },
      {
        title: 'SIDEBAR.DOCUMENTS',
        icon: <DocumentScannerIcon />,
        url: routes.admin.documents.list,
        apiUrl: apiRoutes.documents.list,
      },
      {
        title: 'SIDEBAR.JOB_TITLES',
        icon: <EngineeringIcon />,
        url: routes.admin.jobTitles.list,
        apiUrl: apiRoutes.jobTitles.list,
      },
      {
        title: 'SIDEBAR.DEPARTMENTS',
        icon: <EmojiTransportationIcon />,
        url: routes.admin.departments.list,
        apiUrl: apiRoutes.departments.list,
      },
      {
        title: 'SIDEBAR.TIME_OFFS',
        icon: <AlarmOffIcon />,
        url: routes.admin.employeeTimeOffs.availability,
        apiUrl: apiRoutes.employees.listAvailability,
      },
    ],
  },
];

export const sidebarItems = [
  {
    title: 'SIDEBAR.GROUP_GENERAL',
    items: [
      {
        title: 'SIDEBAR.DASHBOARD',
        icon: <Speed />,
        url: routes.admin.dashboard,
      },
      {
        title: 'SIDEBAR.TASKS',
        icon: <TaskIcon />,
        url: routes.admin.tasks.list,
        apiUrl: apiRoutes.tasks.listForUser,
      },
      {
        title: 'SIDEBAR.DOCUMENTS',
        icon: <DocumentScannerIcon />,
        url: routes.admin.documents.listForEmployee,
        apiUrl: apiRoutes.documents.listForEmployee,
      },
      {
        title: 'SIDEBAR.TIME_OFFS',
        icon: <AlarmOffIcon />,
        url: routes.admin.employeeTimeOffs.availabilityForEmployee,
        apiUrl: apiRoutes.employees.listAvailabilityForEmployee,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_SETTINGS',
    items: [
      {
        title: 'SIDEBAR.DOCUMENT_TEMPLATES',
        icon: <DocumentScannerIcon />,
        url: routes.admin.globalDocumentTemplates.list,
        apiUrl: apiRoutes.globalDocumentTemplates.list,
      },
      {
        title: 'SIDEBAR.COMPANIES',
        icon: <BusinessIcon />,
        url: routes.admin.companies.list,
        apiUrl: apiRoutes.companies.list,
        enabled: process.env.REACT_APP_PLATFORM_ENABLED === 'true',
      },
      {
        title: 'SIDEBAR.USERS',
        icon: <AccountBox />,
        url: routes.admin.users.list,
        apiUrl: apiRoutes.users.list,
      },
      {
        title: 'SIDEBAR.TRANSLATIONS',
        icon: <SpellcheckIcon />,
        url: routes.admin.translations.list,
        apiUrl: apiRoutes.translations.list,
      },
    ],
  },
];

export const sidebarCheckinConfig = {
  enabled: false,
  statusApiUrl: '',
  startLabel: '',
  startApiUrl: '',
  endLabel: '',
  endApiUrl: '',
};

export const sidebarComponentConfig = {
  component: null,
};
